import { Grid, makeStyles } from "@material-ui/core";
import AttachmentModel from "api/models/AttachmentModel";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { ContractAttachmentStore, MessageStore } from "store";
import AttachmentCard from "./AttachmentCard";
import UploadButton from "./UploadButton";

const useStyles = makeStyles({
  container: {
    marginTop: "0.25rem",
    marginLeft: -5,
  },

  paddingItem: { padding: "5px 2.5px" },
});

const AttachmentsContract = observer(({ isEditing, isModal = false }) => {
  const classes = useStyles();

  const handleChangeFiles = (files: File[]) => {
    if (!ContractAttachmentStore.validadeAttachmentsCount(files)) {
      MessageStore.error(lang("attachments.errors.maximumFilesCount"));
      return;
    }

    const promises = Array.from(files).map((file) =>
      ContractAttachmentStore.uploadContractAttachment(file)
    );
    Promise.all(promises);
  };

  const handleDeleteCard = (attachment: AttachmentModel) => {
    ContractAttachmentStore.removeContractAttachment(attachment);
  };

  return (
    <Grid container className={classes.container}>
      <Grid
        item
        className={classes.paddingItem}
        style={{ width: isModal ? "100%" : 50 }}
      >
        <UploadButton showLabel={isModal} onChangeFiles={handleChangeFiles} />
      </Grid>
      {ContractAttachmentStore.attachments.map((att) => (
        <Grid
          item
          xs={isEditing ? 3 : 5}
          xl={isEditing ? 3 : 4}
          className={classes.paddingItem}
          key={att.uid}
        >
          <AttachmentCard attachment={att} onDelete={handleDeleteCard} />
        </Grid>
      ))}
    </Grid>
  );
});

export default AttachmentsContract;
